import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import { useResponse } from 'services/hooks';
import ResultsButtonProps from './ResultsButton.props';
import { RESULTS_DISPLAY } from '../../constants';
import AIIcon from '../assets/AIIcon';

const ResultsButton = ({ jsonResultsString, onClick }: ResultsButtonProps) => {
  const { errorNotification } = useResponse();

  useEffect(() => {
    // parse to ensure valid response type
    try {
      JSON.parse(jsonResultsString);
    } catch (e) {
      errorNotification(RESULTS_DISPLAY.ERROR_PARSING_RESULTS);
    }
  }, [jsonResultsString, errorNotification]);

  return (
    <div>
      <Button onClick={onClick} variant="outlined" color="primary">
        <span style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
          <AIIcon fill={'#037DE8'} />
          {RESULTS_DISPLAY.BUTTON_CONTENT}
        </span>
      </Button>
    </div>
  );
};

export default ResultsButton;
